import { jsxs as s, Fragment as f, jsx as t } from "react/jsx-runtime";
import { useTranslation as L } from "react-i18next";
import e from "./quick-filters.module.less.js";
import { getLabelsForSelectedFilters as N } from "../../../helpers/filter-functions.js";
import { isArrayWithItems as b } from "../../../../../helpers/array-helper.js";
import "dayjs";
const E = ({
  quickFilterGroupName: n,
  selectedFilters: l,
  quickFilters: i,
  onClickOpenAllFilters: d,
  onChangeQuickFilter: p
}) => {
  const { t: o } = L(), r = N(l);
  return /* @__PURE__ */ s(f, { children: [
    /* @__PURE__ */ t("div", { className: e.wrapper, children: /* @__PURE__ */ s("ul", { className: e.filters, children: [
      i?.map((a) => {
        const m = l.get(a.name), h = !!(m && m.value === a.value.toString());
        return /* @__PURE__ */ s("li", { className: e.filter, children: [
          /* @__PURE__ */ t(
            "input",
            {
              className: e.filterRadio,
              type: "checkbox",
              id: n + a.name,
              name: a.name,
              value: a.value.toString(),
              checked: h,
              onChange: (c) => p({
                type: "checkbox",
                checked: c.target.checked,
                name: a.name,
                group: a.group,
                value: c.target.value
              })
            }
          ),
          /* @__PURE__ */ t("label", { htmlFor: n + a.name, className: e.filterLabel, children: a.label })
        ] }, a.name);
      }),
      /* @__PURE__ */ t("li", { className: `${e.filter} ${e.openAllButtonListItem}`, children: /* @__PURE__ */ s(
        "button",
        {
          className: `${e.openAllButton} ${l.size > 0 ? e.selected : ""}`,
          onClick: d,
          children: [
            /* @__PURE__ */ t("span", { className: ["ui-icon-filter", e.allFilterIcon].join(" ") }),
            o("FIND_STATION_OPEN_ALL_FILTERS"),
            l.size > 0 ? ` (${l.size})` : ""
          ]
        }
      ) }, "all-filters")
    ] }) }),
    b(r) && /* @__PURE__ */ s("p", { className: `body-s mt-sm mb-0 ${e.selectedFiltersLabel}`, children: [
      o("FIND_STATION_QUICK_FILTERS_SELECTED_FILTERS_LABEL"),
      " ",
      r.join(", ")
    ] })
  ] });
};
export {
  E as QuickFilters,
  E as default
};
